export const applicationVersion =
    process.env.CURRENT_RELEASE_VERSION || 'Unknown';
